/**
 * useSelectedProvider()
 *
 * Provides:
 * * isSelectedProvider(provider) - determines whether provider is selected or not
 */
import { useCallback } from 'react';

import { useAppSelector } from '@/store/hooks';

export function useSelectedProvider() {
  const providerState = useAppSelector(state => state.paymentSelect.provider);

  const isSelectedProvider = useCallback(
    (provider: string): boolean => (
      provider === providerState
    ),
    [providerState]
  );

  return {
    isSelectedProvider,
  };
}
